export default __webpack_public_path__ + "static/media/BG.11790e45.png";